import React, { useEffect, useState } from 'react';
import { Modal, Card, Tag, Typography, Row, Col, Spin, Empty } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { getRegistroTraslado } from '../../api/mejoraCU2Api';
import type { ReconciliacionTraslado } from '../../api/reconciliacionApi';

const { Text } = Typography;

interface Props {
  casoId: number | null;
  titulo?: string;
  open: boolean;
  onClose: () => void;
}

const Campo: React.FC<{ label: string; value?: string }> = ({ label, value }) => (
  <div style={{ marginTop: 8 }}>
    <Text type="secondary" style={{ fontSize: 12 }}>{label}</Text>
    <div>{value || '—'}</div>
  </div>
);

/** Popup de solo lectura con la información del traslado vinculado al caso. */
const RegistroTrasladoModal: React.FC<Props> = ({ casoId, titulo, open, onClose }) => {
  const [data, setData] = useState<ReconciliacionTraslado | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || casoId == null) return;
    let cancel = false;
    setLoading(true);
    setData(null);
    getRegistroTraslado(casoId)
      .then(r => { if (!cancel) setData(r); })
      .catch(() => { if (!cancel) setData(null); })
      .finally(() => { if (!cancel) setLoading(false); });
    return () => { cancel = true; };
  }, [open, casoId]);

  return (
    <Modal open={open} onCancel={onClose} footer={null} width={720} title={titulo ?? 'Traslado vinculado'}>
      {loading && <div style={{ textAlign: 'center', padding: 32 }}><Spin /></div>}
      {!loading && !data && <Empty description="Sin datos del registro vinculado" />}
      {!loading && data && (
        <>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 12, alignItems: 'center' }}>
            {data.farmaciaGescom?._Name && <Text strong style={{ marginRight: 4 }}>{data.farmaciaGescom._Name}</Text>}
            <Tag color="geekblue">CU2: {data.idFarmaciaCU2}</Tag>
            {data.idFarmaciaGS
              ? <Tag color="green">Gescom: {data.idFarmaciaGS}</Tag>
              : <Tag color="warning">Gescom: sin vincular</Tag>}
          </div>
          <Row gutter={16}>
            <Col span={11}>
              <Card title="Dirección previa" size="small" bordered>
                <Campo label="Dirección" value={data.direccionAnterior} />
                <Campo label="CP" value={data.cpAnterior} />
                <Campo label="Localidad" value={data.localidadAnterior} />
                <Campo label="Provincia" value={data.provinciaAnterior} />
              </Card>
            </Col>
            <Col span={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <ArrowRightOutlined style={{ fontSize: 20, color: '#1890ff' }} />
            </Col>
            <Col span={11}>
              <Card title="Nueva dirección" size="small" bordered style={{ background: '#fff7e6', borderColor: '#ffd591' }}>
                <Campo label="Dirección" value={data.direccion} />
                <Campo label="CP" value={data.cp} />
                <Campo label="Localidad" value={data.localidad} />
                <Campo label="Provincia" value={data.provincia} />
              </Card>
            </Col>
          </Row>
        </>
      )}
    </Modal>
  );
};

export default RegistroTrasladoModal;
